import React from "react";
import { Button, Card, Col, Flex, Layout, Row, Spin } from "antd";
import styles from "../styles/AdminPermission.module.css";
import "./AdminPermission.css";
import { useTranslation } from "react-i18next";


const { Header, Footer, Content } = Layout;

function AdminPermission({
    
}) {
    const { t } = useTranslation()
    return (
        <Layout
            style={{
                backgroundColor: "transparent",
                gap: 10,
            }}
        >
            <Layout style={{ backgroundColor: "transparent" }}>
                {/* Header */}
                <Header
                    style={{
                        backgroundColor: "#0080b3",
                        color: "white",
                        borderRadius: "1rem 1rem 0 0",
                        position: "sticky",
                        top: 0,
                    }}
                >
                    <div
                        className={styles.header}
                        style={{
                            fontWeight: "bold"
                        }}
                    >
                        <div>{t('translation.role.entity')}</div>
                        <div style={{ textAlign: "center" }}>{t('permission.header')}</div>
                    </div>
                </Header>

                <Content style={{ background: "transparent" }}>
                    <Card
                        style={{
                            maxHeight: "150vh",
                            borderRadius: "0 0 1rem 1rem",
                            position: 'sticky'
                        }}
                    >
                        <div
                            className={styles.headerTag}
                            style={{
                                // background: 'transparent',
                                backgroundColor: 'white',
                                // color: 'white',
                                position: 'sticky',
                                top: 0,
                                zIndex: 129,
                                borderRadius: '1rem 1rem 0 0',
                            }}
                        >
                            <div></div>
                            <div style={{ textAlign: "center" }}>{t('permission.label.access')}</div>
                            <div style={{ textAlign: "center" }}>{t('common.create')}</div>
                            <div style={{ textAlign: "center" }}>{t('permission.label.modify')}</div>
                            <div style={{ textAlign: "center" }}>{t('common.delete')}</div>
                        </div>
                        <Row >
                            <Col
                                span={4}
                                style={{
                                    backgroundColor: 'white',
                                    position: 'sticky',
                                    top: 0,
                                    zIndex: 129,
                                    borderRadius: '1rem 1rem 0 0'
                                }}
                            >
                            </Col>
                            <Col
                                span={20}
                                style={{
                                    backgroundColor: "#EDF8FC",
                                    borderRadius: "1rem",
                                    height: "65vh",
                                    overflowY: "auto",
                                }}
                            >
                                <Spin spinning={false}>

                                </Spin>
                            </Col>
                        </Row>
                    </Card>
                </Content>
                {/* <Footer style={{
                    ...(!showSave ? { display: 'none' } : {}),
                    zIndex: 999,
                    bottom: 2,
                    position: 'sticky',
                    backgroundColor: 'white',
                    height: "max-content",
                    placeContent: "center"
                }}>
                    <Flex justify="end" gap={20}>
                        <Button
                            style={{
                                width: "100px", height: "44px", borderRadius: "8px", padding: "8px 16px"
                            }}
                        >
                            {t('common.cancel')}
                        </Button>
                        <Button type="primary" onClick={() => submit()} style={{ width: "100px", height: "44px", borderRadius: "8px", backgroundColor: "var(--button-color)", padding: "8px 16px", color: "white" }}>
                            {t('common.submit')}
                        </Button>
                    </Flex>
                </Footer> */}
            </Layout>
        </Layout>
    );
}
export default AdminPermission;
